<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed, watchEffect, onMounted } from 'vue';
import SmarticoMissions from '@/components/smartico/apostatudo/Missions.vue';
import useSeo from '@/composables/useSeo';
import { getStandardSeoSuffixes } from '@/utils/seoConstants';

const route = useRoute();
const { standardTitleSuffix } = getStandardSeoSuffixes();

const pageTitle = computed(() => {
  if (route.query.type === 'MISSOESDODIA' && route.path === '/vip/missions') {
    return `Missões do Dia ${standardTitleSuffix}`;
  } else if (!route.query.type && route.path === '/vip/missions') {
    return `Missões ${standardTitleSuffix}`;
  }

  return '';
});

watchEffect(() => {
  if (route.path === '/vip/missions') {
    useSeo({
      title: pageTitle.value,
    });
  }
});

onMounted(() => {
  // Mark that we're on a missions page, so when user goes back, filters can be restored
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.setItem('casino_navigation_from_game', 'true');
    } catch (e) {
      // Ignore storage errors
    }
  }
});
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoMissions />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full flex flex-col relative -mt-1 lg:-mt-4;
}
</style>
